'use client'

import { useStoreNavigation } from '@/store'
import { DEBUG, SPOT_CONFIG, USE } from '@spot'
import { ReactLenis, useLenis } from 'lenis/react'
import { usePathname } from 'next/navigation'
import React, { useEffect } from 'react'

interface LenisScrollProps {
  children: React.ReactNode
}

const LenisScroll = ({ children }: LenisScrollProps) => {
  const { setIsRouteTransition } = useStoreNavigation()
  const pathName = usePathname()

  // Note: Scroll restoration is handled per-listing-page by useListScrollRestore hook

  const lenis = useLenis((lenis) => {
    if (!USE.lenis) {
      return
    }
    if (DEBUG.lenis) {
      console.log('----------lenis debug---------')
      console.log('velocity', lenis?.velocity)
      console.log('direction', lenis?.direction)
      console.log('isScrolling', lenis?.isScrolling)
      // console.log('emitter', lenis?.emitter)
      console.log('actualScroll	', lenis?.actualScroll)
      console.log('velocity', lenis?.velocity)
      console.log('isScrolling', lenis?.isScrolling)
      console.log('isSmooth', lenis?.isSmooth)
      console.log('isStopped', lenis?.isStopped)
      console.log('progress', lenis?.progress)
      console.log('scroll', lenis?.scroll)
    }
  })

  useEffect(() => {
    setIsRouteTransition(false)
    if (!lenis) {
      return
    }

    const hash = window.location.hash

    if (hash && hash !== '#/' && !hash.includes('&')) {
      setTimeout(() => {
        if (lenis) {
          lenis?.scrollTo(`${hash}`, { offset: -80, immediate: false })
        }
        if (DEBUG.lenis) {
          console.log('lenis scroll to hash', hash)
        }
      }, 800)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathName, lenis])

  return USE.lenis ? (
    <ReactLenis root options={SPOT_CONFIG.lenis}>
      {children}
    </ReactLenis>
  ) : (
    <>{children}</>
  )
}

export default React.memo(LenisScroll)
